import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { FileUploadState } from "./types";

/**
 * Getters for the File Storage module.
 * Provides computed access to storage type and backend checks.
 */
const getters: GetterTree<FileUploadState, RootState> = {
  /**
   * Returns the current storage backend type.
   *
   * @param {FileUploadState} state - Module state
   * @returns {string} Storage type ('azure' or 'ceph')
   */
  storageType(state, getters, rootState) {
    return state.storageType;
  },

  /**
   * Checks if Azure storage is configured.
   *
   * @param {FileUploadState} state - Module state
   * @returns {boolean} True if using Azure storage
   */
  isAzureStorage(state, getters, rootState) {
    return state.storageType === "azure";
  },

  /**
   * Checks if Ceph storage is configured.
   *
   * @param {FileUploadState} state - Module state
   * @returns {boolean} True if using Ceph storage
   */
  isCephStorage(state, getters, rootState) {
    return state.storageType === "ceph";
  },
};

export default getters;
